module.exports = __webpack_public_path__ + "static/media/my_assets_cycle_plan.c3b3fe64.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/my_assets_cycle_plan.png
// module id = 746
// module chunks = 0 1